export default __webpack_public_path__ + "m_bg12070cb.png";